import { useEffect, useState } from "react";
import { useAuth } from "../auth/AuthContext";
import { api } from "../api/client";

/** 演示账号（与种子数据一致，仅本地 mock 演示模式下展示） */
const DEMO_ACCOUNTS: { wechatUserId: string; name: string; role: string }[] = [
  { wechatUserId: "admin", name: "系统管理员", role: "ADMIN · 全部部门" },
  { wechatUserId: "lead_销售一部", name: "张伟", role: "DEPT_LEAD · 销售一部" },
  { wechatUserId: "lead_产品研发部", name: "刘洋", role: "DEPT_LEAD · 产品研发部" },
  { wechatUserId: "member_销售一部_A", name: "销售一部成员A", role: "MEMBER · 销售一部" },
];

export function LoginPage() {
  const { loginWithDev, startWechatLogin } = useAuth();
  const [error, setError] = useState<string | null>(null);
  const [pending, setPending] = useState<string | null>(null);
  // 探测后端模式：true=本地演示（mock），false/加载失败=生产真实环境
  const [mockMode, setMockMode] = useState<boolean | null>(null);

  useEffect(() => {
    api.auth
      .wechatUrl()
      .then((r) => setMockMode(r.mock))
      .catch(() => setMockMode(false));
  }, []);

  const handleDevLogin = async (wechatUserId: string) => {
    setError(null);
    setPending(wechatUserId);
    try {
      await loginWithDev(wechatUserId);
    } catch (err) {
      setError(err instanceof Error ? err.message : "登录失败，请稍后重试");
    } finally {
      setPending(null);
    }
  };

  const handleWechatLogin = async () => {
    setError(null);
    setPending("wechat");
    try {
      await startWechatLogin();
    } catch (err) {
      setError(err instanceof Error ? err.message : "无法获取登录地址");
      setPending(null);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <h1>📅 会议效能监测与议程跟进平台</h1>
        <div className="sub">MEETING EFFICIENCY &amp; AGENDA TRACKING PLATFORM</div>

        {error && <div className="login-error">{error}</div>}

        <button className="login-btn" onClick={() => void handleWechatLogin()} disabled={pending !== null}>
          {pending === "wechat" ? "正在跳转…" : "💬 企业微信登录"}
        </button>
        <div className="login-hint">
          企业微信内打开自动登录；普通浏览器将跳转扫码页，用企业微信 App 扫码确认
        </div>

        {mockMode && (
          <>
            <div className="login-divider">演示账号快速登录（仅本地演示模式）</div>
            <div className="demo-accounts">
              {DEMO_ACCOUNTS.map((account) => (
                <button
                  key={account.wechatUserId}
                  className="demo-account"
                  onClick={() => void handleDevLogin(account.wechatUserId)}
                  disabled={pending !== null}
                >
                  <div className="avatar">
                    {account.name[0]}
                  </div>
                  <div className="d-info">
                    <div className="d-name">{account.name}</div>
                    <div className="d-role">{account.role}</div>
                  </div>
                  <span className="demo-arrow">{pending === account.wechatUserId ? "…" : "→"}</span>
                </button>
              ))}
            </div>
            <div className="login-note">
              当前为本地演示模式（未配置企业微信凭证），使用 mock 身份与 mock 大模型，数据与交互流程与真实环境一致。
            </div>
          </>
        )}
      </div>
    </div>
  );
}
